// Espelho de TipoDestinoEnum da ATS.Hub.API.Financas (tabela tipo_destino): para onde a forma de
// recebimento lanca o dinheiro.
export enum TipoDestinoEnum {
    ContaBancaria = 1,
    ContaFinanceira = 2,
    ContasAReceber = 3,
    Caixa = 4,
}
